import React, { 
  useEffect, 
  useRef 
} from "react";
import TextInputField from "controls/global/text-input-field";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { useSpaceAgencyConfig } from "utils/context/SpaceContext";
import { IconButton } from "@mui/material";
import EditFilledIcon from "theme/icons/EditFilledIcon";
import EditEmailNotificationDialog from "./EditEmailNotificationDialog";
import { DialogRefType } from "entities/UIModel";
import { OrderStatusType } from "utils/data/enum";
import useFieldDisabler from "utils/custom-hooks/useFieldDisabler";
// import { DOMEventType } from "utils/data/enum";

interface Props {
  schema: string;
  name: string;
  isTitleSearchDisabled: boolean;
  disabled?: boolean;
  onChange?: () => void;  
}

const NotificationEmailAddresses = ({schema, name, isTitleSearchDisabled = false, disabled, onChange}: Props) => {
  const {setValue, getValues, clearErrors, trigger} = useFormWrapper();
  const [{ tsAgencyConfig }] = useSpaceAgencyConfig();
  const isFileDisabled = useFieldDisabler("AddTitleSearchButton");

  const editDialogRef = useRef<DialogRefType>(null);

  const notificationEmailAddresses = getValues(name);
  const orderStatus = getValues(`${schema}.orderStatusTypeCode`);
  const editEmailEnabled: boolean = !isTitleSearchDisabled && (orderStatus === OrderStatusType.InProgress || orderStatus === OrderStatusType.UpdateInProgress);

  const validateNotificationEmailAddress = () => {
    if (notificationEmailAddresses && !disabled ) {
      clearErrors(name);
      setValue(`${schema}.isValidationRequired`, true);
      trigger(name);      
    }    
  }

  const handleOnChange = (event: React.ChangeEvent<any>) => {
    setValue(`${schema}.isDefault`, false);
    setValue(`${schema}.isNotificationEmailAddressesDirty`, true);

    onChange && onChange();
  }

  const handleOnBlur = () => {
    validateNotificationEmailAddress();
  }

  const handleEditNotificationEmail = () => {
    editDialogRef.current?.open();
  }

  useEffect(() => {
    // console.log(tsAgencyConfig);
    const productID: number = getValues(`${schema}.productID`)
    const isNotificationEmailAddressesDirty: boolean = getValues(
      `${schema}.isNotificationEmailAddressesDirty`
    );
    if (!isNotificationEmailAddressesDirty && productID === 0) {
      // Use default Email from SPACE agency config
      const defaultEmail = tsAgencyConfig?.emailAddress;
      setValue(name, defaultEmail);
    }    
  },[tsAgencyConfig?.emailAddress, notificationEmailAddresses])

  // useEffect(() => {
  //   document.addEventListener(DOMEventType.FILE_JUST_LOADED, fileLoadedProcess);
  //   return () => {
  //     document.removeEventListener(
  //       DOMEventType.FILE_JUST_LOADED,
  //       fileLoadedProcess
  //     );
  //   };
  // });  

  // useEffect(() => {
  //   validateNotificationEmailAddress();
  // })

  return (
    <>
    <TextInputField
      name={name}
      placeholder="Email"
      label="Email For Notifications"
      style={{ position: "relative" }}
      disabled={disabled}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      InputProps={disabled && ({
        endAdornment: 
          <IconButton disabled={!editEmailEnabled || isFileDisabled} onClick={handleEditNotificationEmail}>
            <EditFilledIcon />
          </IconButton>
        ,
      })}
    />
    <EditEmailNotificationDialog 
      ref={editDialogRef}
      schema={schema}
      currentFieldName={name}
      newFieldName={`${schema}.notificationEmailAddressesEdited`}
    />
    </>
  );

}


export default NotificationEmailAddresses;